// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__LuAC0"};